import styled from "styled-components";
import Color from "../../assets/color";

const MenuCardStyled = styled.div`
  .product-container {
    display: flex;
    cursor: pointer;
    padding-left: 0.8rem;
    position: relative;

    .invalid {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(255, 255, 255, 0.4);
      z-index: 2;
    }

    .image-container {
      position: relative;
      padding-top: 0.8rem;
      padding-bottom: 0.8rem;
      padding-right: 0.8rem;
      z-index: 3;

      .product-image-wrapper {
        position: relative;
        width: 75px;
        height: 75px;

        @media (max-width: 991px) {
          width: 60px;
          height: 60px;
        }

        .product-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .sold-out {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          padding: 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(0, 0, 0, 0.5);
          font-family: "Lato Bold", sans-serif;
          color: ${Color.white};
          text-transform: uppercase;
          text-align: center;
        }
      }
    }

    .product-detail {
      flex: 1;
      padding: 0.8rem;
      padding-left: 0;
      border-top: 1px solid ${Color.athens};

      .product-info {
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: space-between;

        .info {
          p {
            margin-bottom: 3px;
          }
          .product-name {
            font-family: "Lato Bold", sans-serif;
            margin-bottom: 3px;
          }
          .description,
          .serving-period {
            color: ${Color.emperor};
          }
          .more-serving-period {
            font-family: "Lato Bold", sans-serif;
            color: ${Color.primary};
            display: block;
          }
          .discount {
            display: flex;

            .badge {
              margin-top: 3px;
              margin-bottom: auto;
              line-height: normal;
            }
            .text {
              margin-left: 5px;
            }
          }
        }

        .price {
          display: flex;
          align-items: center;

          .original {
            margin-left: 1rem;
          }
        }

        @media (min-width: 992px) {
          padding-right: 0.8rem;
        }
      }

      .food-label {
        display: flex;
        flex-wrap: wrap;

        .label {
          padding: 4px;

          .icon-chef {
            width: 15px;
            height: 15px;
            object-fit: cover;
          }
        }
      }

      .price {
        .selling {
          font-family: "Lato Bold", sans-serif;
          font-size: 14px;
        }
        .original {
          color: ${Color.nobel};
          text-decoration: line-through;
        }
      }

      .order-type {
        display: flex;

        .btn-option {
          position: relative;

          .badge {
            position: absolute;
            top: -5px;
            right: -5px;
          }
        }

        .icon-order-type {
          background: ${Color.aliceBlue};
          border: 4px solid #fff;
          border-radius: 100%;
          width: 42px;
          height: 42px;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: -8px;

          &.disabled {
            background: ${Color.athens};
            svg {
              fill: ${Color.aluminium};
            }
          }

          @media (max-width: 991px) {
            width: 35px;
            height: 35px;

            svg {
              width: 15px;
              height: 15px;
            }
          }
        }
      }

      .price-order-container {
        z-index: 3;
      }

      @media (max-width: 991px) {
        .price-order-container {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;

          .price {
            .selling,
            .original {
              display: block;
            }
          }
        }
      }

      @media (min-width: 992px) {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;

        .product-info {
          height: 100%;
        }
      }
    }
  }

  &.first {
    .product-container {
      .product-detail {
        border-top: 1px solid transparent;
      }
    }
  }
`;

export default MenuCardStyled;
